// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpiryDate
 */
export interface IExpiryDate {
    /**
     * 
     * @type {string}
     * @memberof IExpiryDate
     */
    month: string;
    /**
     * 
     * @type {string}
     * @memberof IExpiryDate
     */
    year: string;
    /**
     * 
     * @type {string}
     * @memberof IExpiryDate
     */
    single_value?: string;
}

/**
 * Check if a given object implements the IExpiryDate interface.
 */
export function instanceOfIExpiryDate(value: object): value is IExpiryDate {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    return true;
}

export function IExpiryDateFromJSON(json: any): IExpiryDate {
    return IExpiryDateFromJSONTyped(json, false);
}

export function IExpiryDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpiryDate {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'year': json['year'],
        'single_value': json['singleValue'] == null ? undefined : json['singleValue'],
    };
}

export function IExpiryDateToJSON(json: any): IExpiryDate {
    return IExpiryDateToJSONTyped(json, false);
}

export function IExpiryDateToJSONTyped(value?: IExpiryDate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'year': value['year'],
        'singleValue': value['single_value'],
    };
}

